import { useFormikContext } from 'formik'
import type { ILeadFormModel } from '../../typings'
import { useGetSalesTeamPermissionMessages } from '@user/store/salesTeam'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'
import { guestRoleName } from '@user/components/Settings/Users/UpdateUser/constants'

export function useData() {
  const {
    values: { salesTeamId, assigneeId },
  } = useFormikContext<ILeadFormModel>()

  const currentUser = useSelector(selectCurrentUser)
  const isGuestUser = currentUser?.roleName === guestRoleName

  const { disableSaveAndView } = useGetSalesTeamPermissionMessages(
    'success',
    +salesTeamId,
    assigneeId,
  )

  return { disableSaveAndView: !isGuestUser && disableSaveAndView }
}
